<div
  class="dialog"
  *ngIf="this.config.isVisible"
  [style.width]="config.width"
  [style.height]="config.height"
  [class.overflow-disabled]="config.isOverflowDisabled"
>
  <div class="topbar">
    <h1 class="title heading-01-bold">{{ config.title }}</h1>
    <qr-button
      *ngIf="!this.config.isNotCloseable"
      class="button-close"
      [config]="buttonClose"
      (click)="close()"
      matTooltip="Cerrar"
    ></qr-button>
  </div>
  <!-- Contenido dinámico -->
  <div
    class="content"
    [style.height]="config.height"
    [ngStyle]="{ height: this.getContentHeight() }"
    [class.overflow-disabled]="config.isOverflowDisabled"
  >
    <template #dinamicContainer></template>
  </div>
  <div
    class="botbar"
    *ngIf="
      this.config.textButtonAction ||
      this.config.textButtonCancel ||
      this.config.textButtonAction2
    "
  >
    <div class="botbar-actions">
      <qr-button
        *ngIf="this.config.textButtonCancel"
        [config]="buttonCancel"
        (click)="closeButton()"
        class="button-cancel"
      ></qr-button>
      <qr-button
        *ngIf="this.config.textButtonAction2"
        [config]="buttonAction2"
        (click)="action2()"
        class="button-action"
      ></qr-button>
      <qr-button
        *ngIf="this.config.textButtonAction"
        [config]="buttonAction"
        (click)="action()"
        [isDisabled]="buttonActionDisabled"
        class="button-action"
      ></qr-button>
    </div>
  </div>
</div>

<div class="shadow" *ngIf="this.config.isVisible" (click)="close()"></div>